function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import { font } from '../../utils/helpers';
var Link = styled.a(_templateObject(), function (_ref) {
  var theme = _ref.theme,
      isDisabled = _ref.disabled,
      background = _ref.background;
  var text = theme.text,
      link = theme.link,
      colors = theme.colors;
  var backgroundType = Link.getBackgroundType(background);
  var _link$backgroundType = link[backgroundType],
      inactive = _link$backgroundType.inactive,
      focus = _link$backgroundType.focus,
      active = _link$backgroundType.active,
      disabled = _link$backgroundType.disabled;
  return _extends({}, font(text.shared.bold), {
    cursor: 'pointer',
    pointerEvents: isDisabled ? 'none' : undefined,
    backgroundColor: colors[background],
    color: !isDisabled ? colors[inactive.color] : colors[disabled.color],
    textDecorationColor: !isDisabled ? colors[inactive.textDecorationColor] : colors[disabled.textDecorationColor],
    ':hover,:focus': {
      color: colors[focus.color],
      textDecorationColor: colors[focus.textDecorationColor]
    },
    ':active': {
      color: colors[active.color],
      textDecorationColor: colors[active.textDecorationColor]
    }
  });
});

Link.getBackgroundType = function (background) {
  switch (background) {
    case 'functionalDimmedSuccess':
    case 'functionalDimmedError':
    case 'functionalDimmedInfo':
    case 'functionalDimmedAlert':
      return 'bgFunctional';

    case 'black':
    case 'grey1':
      return 'bgBlack';

    case 'white':
    case 'grey2':
    default:
      return 'bgWhite';
  }
};

Link.propTypes = {
  background: PropTypes.oneOf(['white', 'black', 'grey1', 'grey2', 'functionalDimmedSuccess', 'functionalDimmedError', 'functionalDimmedInfo', 'functionalDimmedAlert'])
};
Link.defaultProps = {
  background: 'white'
};
export default Link;